import type { Id } from '@e-socna/data-layer';

import { filterRetainedServiceUsagesGroups } from './retained-service-usages-groups.util';

type ChoicePart = Readonly<{
  // The choice of one mission (null: every option of its groups).
  selectedOptionGroupIds: readonly Id[] | null | undefined;
  groups: readonly Readonly<{ _id: Id; isOptional?: boolean }>[];
}>;

// Same rule as the back (combineOptionGroupsChoices): the choice of groups
// priced by several missions, each mission keeping the choice of its own.
export const combineOptionGroupsChoices = (
  parts: readonly ChoicePart[],
): readonly Id[] | null => {
  if (parts.every(({ selectedOptionGroupIds }) => !selectedOptionGroupIds)) {
    return null;
  }

  return parts.flatMap(({ selectedOptionGroupIds, groups }) =>
    filterRetainedServiceUsagesGroups(groups, selectedOptionGroupIds)
      .filter((group) => group.isOptional)
      .map((group) => group._id),
  );
};
